module.exports = __webpack_public_path__ + "static/media/doc.492a63ba.svg";